import { render, staticRenderFns } from "./CutleryQty.vue?vue&type=template&id=1ff8f056&"
import script from "./CutleryQty.vue?vue&type=script&lang=js&"
export * from "./CutleryQty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports